/** @format */

import React from "react";
import ChangePasswordPage from "../components/change-password/changePasswordPage";
import LoginPage from "../pages/login/LoginPage";
import RegistrationPageNew from "../components/registration/RegistrationPageNew";
import PrivacyPolicyPage from "../components/documents/PrivacyPolicyPage";
import TermsUsePage from "../components/documents/TermsUsePage";
import NewPasswordPage from "../components/forgot-password/NewPasswordPage";
import ConfirmEmailPage from "../components/confirm-email/ConfirmEmail";
import OrdersList from "../pages/orders/list";
import ProfilePageComponentTwo from "../components/profileTwo/ProfilePageComponentTwo";
import OrdersCreatePage from "../pages/orders/create";
import BalanceLists from "../pages/balance/list";
import PageInDevelopPage from "../pages/page-in-develop";
import VerifyDocs from "../pages/verify-docs";
import Layouts from "../layouts";
import OrdersAvailable from "../pages/orders/available";
import OrdersDraftList from "../pages/orders/list-draft";
import Drivers from "../pages/drivers";
import DriversCreate from "../pages/drivers/create";
import CarsPage from "../pages/cars";
import CarsCreatePage from "../pages/cars/create";
import OrdersInProgressPage from "../pages/orders/in-progress";
import Index from "../pages/develop/IconsPage";
import NotificationPage from "../pages/notification";
import WorkersPage from "../pages/workers";
import WorkersCreatePage from "../components/workers/create/WorkersCreatePage";
import ConfirmEmployeePage from "../components/workers/confirm-employee/ConfirmEmployee";
import WorkersEditPage from "../components/workers/edit/WorkersEditPage";
import ForgotPasswordPageNew from "../components/forgot-password-new/ForgotPasswordPageNew";
import OnboardingPage from "../pages/onboarding";
import AnalyticsPage from "../pages/analytics";
import PartnersPage from "../pages/partners";
import OnboardingExpeditorPage from "../pages/onboarding-expeditor";
import OrdersCopyPage from "../pages/orders/create-copy/OrdersCopyPage";
import OrderSearchPage from "../pages/orders/orders-search";
import ExpeditorOrdersCreatePage from "../pages/orders/create-expeditor";
import ExpeditorOrdersCopyPage from "../pages/orders/create-copy-expeditor";
import RegistrationCnPage from "../components/registration-cn/RegistrationPageNew";

export const routes = [
  {
    name: "login",
    title: "Login page",
    Component: LoginPage,
    Layout: Layouts.Without,
    path: "/login",
  },
  {
    name: "registration",
    title: "Registration page",
    Component: RegistrationPageNew,
    Layout: Layouts.Without,
    path: "/registration",
  },
  {
    name: "registration-cn",
    title: "Registration Chinese Page",
    Component: RegistrationCnPage,
    Layout: Layouts.Without,
    path: "/cn/registration",
  },
  {
    name: "privacy-policy",
    title: "Privacy-policy page",
    Component: PrivacyPolicyPage,
    Layout: Layouts.Without,
    path: "/privacy-policy",
  },
  {
    name: "terms-of-use",
    title: "Terms of use page",
    Component: TermsUsePage,
    Layout: Layouts.Without,
    path: "/privacy",
  },
  {
    name: "forgot-password",
    title: "Forgot password page",
    Component: ForgotPasswordPageNew,
    Layout: Layouts.Without,
    path: "/forgot-password",
  },
  {
    name: "/auth/reset-password/:code",
    title: "Reset password code page",
    Component: NewPasswordPage,
    Layout: Layouts.Without,
    path: "/auth/reset-password/:code",
  },
  {
    name: "/auth/confirm-email/:code",
    title: "Confirm email page",
    Component: ConfirmEmailPage,
    Layout: Layouts.Without,
    path: "/auth/confirm-email/:code",
  },
  {
    name: "/auth/confirm-employee/:code",
    title: "Confirm employee code page",
    Component: ConfirmEmployeePage,
    Layout: Layouts.Without,
    path: "/auth/confirm-employee/:code",
  },
  {
    name: "onboarding",
    title: "onboarding page",
    Component: OnboardingPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/onboarding",
  },
  {
    name: "onboarding-expeditor",
    title: "onboarding for a expeditor page",
    Component: OnboardingExpeditorPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/onboarding-expeditor",
  },
  {
    name: "main",
    title: "Orders page",
    Component: OrdersList,
    Layout: Layouts.Main,
    Private: true,
    path: "/main",
  },
  {
    name: "orders-create",
    title: "Orders create page",
    Component: OrdersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/create",
  },
  {
    name: "expeditor-orders-create",
    title: "Expeditor orders create page",
    Component: ExpeditorOrdersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/expeditor/orders/create",
  },
  {
    name: "orders-available",
    title: "Orders available page",
    Component: OrdersAvailable,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/available",
  },
  {
    name: "orders-search",
    title: "Orders search page",
    Component: OrderSearchPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders-search",
  },
  {
    name: "orders-draft",
    title: "Orders draft page",
    Component: OrdersDraftList,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/draft",
  },
  {
    name: "orders-draft-id",
    title: "Order draft detail page",
    Component: OrdersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/draft/:id/edit",
  },
  {
    name: "orders-draft-id",
    title: "Order draft detail page",
    Component: ExpeditorOrdersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/expeditor/orders/draft/:id/edit",
  },
  {
    name: "orders-copy-id",
    title: "Order copy page",
    Component: OrdersCopyPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/copy/:id",
  },
  {
    name: "expeditor-orders-copy-id",
    title: "Expeditor orders copy page",
    Component: ExpeditorOrdersCopyPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/expeditor/orders/copy/:id",
  },
  {
    name: "orders-edit-id",
    title: "Order edit page",
    Component: OrdersCopyPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/edit/:id",
  },
  {
    name: "expeditor-orders-edit-id",
    title: "Expeditor orders edit page",
    Component: ExpeditorOrdersCopyPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/expeditor/orders/edit/:id",
  },
  {
    name: "orders-in-progress",
    title: "Orders in progress page",
    Component: OrdersInProgressPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/in-progress",
  },
  {
    name: "profile",
    title: "Profile page",
    Component: ProfilePageComponentTwo,
    Layout: Layouts.Main,
    Private: true,
    path: "/profile",
  },
  {
    name: "change-password",
    title: "Change password page",
    Component: ChangePasswordPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/change-password",
  },
  {
    name: "drivers",
    title: "drivers page",
    Component: Drivers,
    Layout: Layouts.Main,
    Private: true,
    path: "/drivers",
  },
  {
    name: "drivers-create",
    title: "drivers create page",
    Component: DriversCreate,
    Layout: Layouts.Main,
    Private: true,
    path: "/drivers/create",
  },
  {
    name: "cars",
    title: "cars page",
    Component: CarsPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/cars",
  },
  {
    name: "cars-create",
    title: "drivers create page",
    Component: CarsCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/cars/create",
  },
  {
    name: "balance/lists",
    title: "balance/lists page",
    Component: BalanceLists,
    Layout: Layouts.Main,
    Private: true,
    path: "/balance/lists",
  },
  {
    name: "partners",
    title: "partners page",
    Component: PartnersPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/partners",
  },
  {
    name: "workers",
    title: "workers page",
    Component: WorkersPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/workers",
  },
  {
    name: "workers-create",
    title: "workers create page",
    Component: WorkersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/workers/create",
  },
  {
    name: "workers-edit-id",
    title: "workers edit page",
    Component: WorkersEditPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/workers/edit/:id",
  },
  {
    name: "analytics",
    title: "analytics page",
    Component: AnalyticsPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/analytics",
  },
  {
    name: "verify-docs",
    title: "verify-docs page",
    Component: VerifyDocs,
    Layout: Layouts.Main,
    Private: true,
    path: "/verify-docs",
  },
  {
    name: "notification",
    title: "notification page",
    Component: NotificationPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/notification",
  },
  {
    name: "support",
    title: "support page",
    Component: PageInDevelopPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/support",
  },
  {
    name: "icons",
    title: "icons page",
    Component: Index,
    Layout: Layouts.Main,
    path: "/develop/icons",
  },
];
